<template>
  <div>
    <b-modal
        no-close-on-esc
        hide-header-close
        ref="LateNightPopup"
        id="LateNightPopup"
        hide-header
        hide-footer
        class="country-modal"
      >

        <div class="p-3 text-center">
          <h5>This is late night show (Early Hours of Next Day)</h5>
          {{JSON.stringify(data1)}}
          <button class="btn btn-pink" @click="closeLateNightPopup()">OK</button>
        </div>
      </b-modal>

    <b-modal
      ref="quickBookModal"
      id="quickBookModal"
      hide-footer
      hide-header
      class="quickBookModal"
      centered
    >
      <div
        class="row col-xl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 mx-0 px-0"
      >
        <!--BY MOVIE-->
        <div
          v-if="quickbookby == 'movie'"
          class="text-center col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center cinema-dd by-cinema-if-movie-c-dd"
        >
          <h4 class="mb-0 " style="color:white;">
            <span>
              <img width="30px" src="@/assets/img/icon-quickbook.png" />
            </span>
            QUICKBOOK
          </h4>
        </div>
        <!-- MOVIE -->
        <div
          v-if="quickbookby == 'movie'"
          class="col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pr-sm-2 px-lg-2  by-movie-if-movie-m-dd align-self-center margin_bottom_small_device"
        >
          <b-dropdown
            no-flip
            ref="dropdown"
            id="ddown1"
            :text="
              quickBook.movieSelected.title == 'Select Movie'
                ? $t('SELECT_MOVIE')
                : quickBook.movieSelected.title
            "
            variant="default"
            class="tt-dropdown wide-dropdown"
            @toggle="onClickMovieDropDown()"
          >
            <div class="p-2">
              <input
                class="quick-input"
                type="search"
                placeholder="..."
                id="movieSearchId"
                autofocus
                required
                v-on:keyup="onKeyUp('movie')"
                v-on:keydown="onKeyUp('movie')"
                v-model="movieSearch"
              />
            </div>
            <b-dropdown-item
              v-if="filteredMovies.length > 0"
              v-for="(movie, Index) in filteredMovies"
              :title="movie.title"
              :key="Index"
              class="text-over"
              v-on:click="newQuickBookFilter(movie, 'cinema', $event, movie.id)"
              >{{ movie.title }}
            </b-dropdown-item>
            <b-dropdown-item v-else>{{
              $t("NO_MOVIES_FOUND")
            }}</b-dropdown-item>
          </b-dropdown>
        </div>
        <!-- CINEMA -->
        <div
          v-else
          class="col-xl-3 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2  margin_bottom_small_device align-self-center cinema-dd by-movie-else-movie-c-dd"
        >
          <b-dropdown
            ref="cinemaDropdown"
            id="ddown1"
            no-flip
            :text="
              quickBook.cinemaSelected.title == 'Select Cinema'
                ? $t('SELECT_CINEMA')
                : quickBook.cinemaSelected.title
            "
            variant="default"
            class="tt-dropdown wide-dropdown"
            @toggle="
              onClickMovieDropDown() == true ? onClickCinemaDropDown() : ''
            "
            :disabled="
              quickbookby === 'movie' &&
                quickBook.movieSelected.title == 'Select Movie'
            "
          >
            <div class="p-2">
              <input
                class="quick-input"
                type="search"
                placeholder="..."
                autofocus
                required
                v-on:keyup="onKeyUp('cinema')"
                v-on:keydown="onKeyUp('cinema')"
                v-model="cinemaSearch"
              />
            </div>

            <div class="curve">
              <b-dropdown-item
                v-for="(cinema, Index) in quickBook.cinemas"
                :title="cinema.title"
                :key="Index"
                class="text-over"
                id="button-2"
                v-on:click="
                  newQuickBookFilter(cinema, 'dates', $event, cinema.id)
                "
              >
                {{ cinema.title }}
                <!-- <b-tooltip target="button-2" placement="left" :title="cinema.CinemaName"></b-tooltip> -->
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </div>

        <!--BY CINEMA-->
        <!-- CINEMA -->
        <div
          v-if="quickbookby == 'movie'"
          class="col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center cinema-dd by-cinema-if-movie-c-dd"
        >
          <b-dropdown
            ref="cinemaDropdown"
            id="ddown1"
            no-flip
            :text="
              quickBook.cinemaSelected.title == 'Select Cinema'
                ? $t('SELECT_CINEMA')
                : quickBook.cinemaSelected.title
            "
            variant="default"
            class="tt-dropdown wide-dropdown"
            @toggle="
              onClickMovieDropDown() == true ? onClickCinemaDropDown() : ''
            "
            :disabled="
              quickbookby === 'movie' &&
                quickBook.movieSelected.title == 'Select Movie'
            "
          >
            <div class="p-2">
              <input
                class="quick-input"
                type="search"
                placeholder="..."
                autofocus
                required
                v-on:keyup="onKeyUp('cinema')"
                v-on:keydown="onKeyUp('cinema')"
                v-model="cinemaSearch"
              />
            </div>

            <div class="curve">
              <b-dropdown-item
                v-for="(cinema, Index) in quickBook.cinemas"
                :title="cinema.title"
                :key="Index"
                class="text-over"
                id="button-2"
                v-on:click="
                  newQuickBookFilter(cinema, 'dates', $event, cinema.id)
                "
              >
                {{ cinema.title }}
                <!-- <b-tooltip target="button-2" placement="left" :title="cinema.CinemaName"></b-tooltip> -->
              </b-dropdown-item>
            </div>
          </b-dropdown>
        </div>
        <!-- MOVIE -->
        <div
          v-else
          class="col-xl-3 col-sm-6 col-md-6 col-lg-6 px-0 pr-sm-2 px-lg-2  margin_bottom_small_device align-self-center by-cinema-else-movie-m-dd"
        >
          <b-dropdown
            no-flip
            ref="dropdown"
            id="ddown1"
            :text="
              quickBook.movieSelected.title == 'Select Movie'
                ? $t('SELECT_MOVIE')
                : quickBook.movieSelected.title
            "
            variant="default"
            class="tt-dropdown wide-dropdown"
            @toggle="onClickMovieDropDown()"
            :disabled="
              quickbookby === 'cinema' &&
                quickBook.cinemaSelected.title == 'Select Cinema'
            "
          >
            <div class="p-2">
              <input
                class="quick-input"
                type="search"
                placeholder="..."
                id="movieSearchId"
                autofocus
                required
                v-on:keyup="onKeyUp('movie')"
                v-on:keydown="onKeyUp('movie')"
                v-model="movieSearch"
              />
            </div>
            <b-dropdown-item
              v-if="filteredMovies.length > 0"
              v-for="(movie, Index) in filteredMovies"
              :title="movie.title"
              :key="Index"
              class="text-over"
              v-on:click="newQuickBookFilter(movie, 'cinema', $event, movie.id)"
              >{{ movie.title }}
            </b-dropdown-item>
            <b-dropdown-item v-else>{{
              $t("NO_MOVIES_FOUND")
            }}</b-dropdown-item>
          </b-dropdown>
        </div>

        <!-- DATE -->
        <div
          class="col-xl-2 col-sm-6 col-md-6 col-lg px-0 pr-sm-2 margin_bottom_small_device px-lg-2 align-self-center"
        >
          <b-dropdown
            ref="dateDropdown"
            id="ddown1"
            no-flip
            :text="
              quickBook.dateSelected.title == 'Select Date'
                ? $t('SELECT_DATE')
                : quickBook.dateSelected.title
            "
            variant="default"
            class="tt-dropdown"
            :disabled="quickBook.cinemaSelected.title == 'Select Cinema'"
            @toggle="
              quickBook.cinemaSelected.title != 'Select Cinema'
                ? onClickDateDropDown()
                : ''
            "
          >
            <b-dropdown-item
              v-for="(date, Index) in quickBook.dates"
              :key="Index"
              v-on:click="newQuickBookFilter(date, 'time', $event, date.id)"
              >{{ date.title }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <!-- SHOWTIME -->
        <div
          class="col-xl-2 col-sm-6 col-md-6 col-lg px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center"
        >
          <b-dropdown
            ref="showtimeDropdown"
            no-flip
            id="ddown1"
            :text="
              quickBook.timeSelected.title == 'Select Time'
                ? $t('SELECT_TIME')
                : quickBook.timeSelected.title
            "
            variant="default"
            class="tt-dropdown"
            :disabled="quickBook.dateSelected.title == 'Select Date'"
            @toggle="
              quickBook.dateSelected.title != 'Select Date'
                ? onClickShowtimeDropDown()
                : ''
            "
          >
            <b-dropdown-item
              v-for="(time, Index) in quickBook.times"
              :key="Index"
              v-on:click="newQuickBookFilter(time, 'book', $event, time.id)"
              ><div class="d-flex movie-moon-hover" style="height:25px" @click="checkLateNightPopup(time.Latenightpopup)">
                      <span>{{ time.title }}</span>
                      <figure v-if="time.Latenightpopup" style="margin-left:10px">
                          <img src="@/assets/img/half-moon.svg" />
                      </figure>
                    </div></b-dropdown-item
            >
          </b-dropdown>
        </div>

        <div
          class=" col-xl-2 col-md-12 col-lg-12 text-center px-0 pl-lg-2 align-self-center"
        >
          <router-link
            class="text-white"
            to
            v-on:click.native="onClickShowTimes(quickBook.timeSelected)"
          >
            <button
              class=""
              :disabled="
                movie_link_id && cinema_id && show_date && show_time == false
              "
              :class="[
                movie_link_id == false ||
                cinema_id == false ||
                show_date == false ||
                show_time == false
                  ? 'qb-btn-disabled'
                  : 'qb-btn'
              ]"
            >
              {{ $t("BOOK_NOW") }}
            </button>
          </router-link>
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      ref="tncModal"
      id="tncModal"
      hide-header
      hide-footer
      class="country-modal"
    >
      <div class="modal-title">Usage Terms and Conditions</div>
      <div class="mx-2">
        <ol class="list-group text-white px-4">
          <li>Ticket is Compulsory for Children of 2 years & Above.</li>
          <li>
            Age restrictions apply as per the certification and suitability of
            the film.
          </li>
          <li>
            At the Cinema’s discretion and in accordance with UAE regulations,
            Cinema’s reserves the right to request proof of ID and users can be
            asked to leave by the cinema if they are under the permissible age
            of a movie.
          </li>
          <li>
            Returns and exchanges on purchased tickets through the Ticketak
            platform are not permitted.
          </li>
          <li>
            Decisions taken by Cinema’s Management team is final & abiding.
          </li>
          <li>
            Outside food & Beverages is not permitted inside cinema premises.
          </li>
        </ol>
      </div>

      <div class="row mx-0 py-3">
        <div class="col-6">
          <button
            type="button"
            v-on:click="onCancel()"
            class="btn-confirm active"
          >
            Cancel
          </button>
        </div>
        <div class="col-6">
          <button
            type="button"
            v-on:click="onAccept(movieID, timingList)"
            class="btn-confirm active"
          >
            Accept
          </button>
        </div>
      </div>
    </b-modal>
    <div class="wrapper pt-0">
      <!-- <div class="col-12 col-md-12 col-lg-12 col-xl-11 mx-auto pl-0">
        <div class="d-flex">
          <span class="quick_title">
            {{$t("QUICK_BOOK")}}
            <span >
                <img class="arrow_img_new" src="@/assets/img/arrow-quick-booking.png"/>
            </span>
            </span>
            <div class="btn_back">
          <button
                class="quickbook_btn ml-2"
                @click="setquickbookby('movie')"
                :class="quickbookby == 'movie' ? 'back_active' : ''"
             >
                  {{$t("BY_MOVIE")}}
                </button>
                <span class="text-light mx-1">|</span>
                <button
                class="quickbook_btn"
                @click="setquickbookby('cinema')"
                :class="quickbookby == 'cinema' ? 'back_active' : ''"
                >
                  {{$t("BY_CINEMA")}}
                </button>
                </div>
        </div>
      </div> -->
      <!--MOBILE QUICKBOOK-->
      <div class="d-block d-md-none">
        <div
         v-b-modal.quickBookModal
          class="col-12 col-md-12 col-lg-12 col-xl-11 mx-auto quickbook p-2 p-xl-2 h-100"
        >
          <h4 class="text-center mb-0">
            <span>
              <img width="30px" src="@/assets/img/icon-quickbook.png" />
            </span>
            QUICK BOOK
          </h4>
        </div>
      </div>
      <!--DESKTOP QUICKBOOK-->
      <div class="d-none d-md-block">
        <div
          class="col-12 col-md-12 col-lg-12 col-xl-11 mx-auto quickbook p-2 p-xl-2 h-100"
        >
          <div class="row mx-0 align-items-center justify-content-center">
            <!-- QUICKBOOK -->
            <div
              class="col-md-12 col-lg d-flex  px-0 mb-3 mb-3 "
              style="gap:25px; padding-top: 15px;"
              v-if="false"
            >
              <div class="qb-text d-flex  align-items-center">
                <!--img class="mr-2" src="@/assets/img/icon-quickbook.png" height="35px" width="35px" /-->
                {{ $t("QUICK_BOOK") }}
              </div>

              <div class="d-flex" style="gap:15px">
                <b-button class="" @click="setquickbookby('movie')">
                  {{ $t("BY_MOVIE") }}
                </b-button>

                <b-button class="" @click="setquickbookby('cinema')">
                  {{ $t("BY_CINEMA") }}
                </b-button>
              </div>
            </div>

            <div
              class="row col-xl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 px-xl-0"
            >
              <!--BY MOVIE-->
              <div
                v-if="quickbookby == 'movie'"
                class="col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center cinema-dd by-cinema-if-movie-c-dd"
              >
                <h4 class="mb-0 d-none d-md-block" style="color:white;">
                  <span>
                    <img width="30px" src="@/assets/img/icon-quickbook.png" />
                  </span>
                  QUICKBOOK
                </h4>
              </div>
              <!-- MOVIE -->
              <div
                v-if="quickbookby == 'movie'"
                class="col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pr-sm-2 px-lg-2  by-movie-if-movie-m-dd align-self-center margin_bottom_small_device"
              >
                <b-dropdown
                  no-flip
                  ref="dropdown"
                  id="ddown1"
                  :text="
                    quickBook.movieSelected.title == 'Select Movie'
                      ? $t('SELECT_MOVIE')
                      : quickBook.movieSelected.title
                  "
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="onClickMovieDropDown()"
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      id="movieSearchId"
                      autofocus
                      required
                      v-on:keyup="onKeyUp('movie')"
                      v-on:keydown="onKeyUp('movie')"
                      v-model="movieSearch"
                    />
                  </div>
                  <b-dropdown-item
                    v-if="filteredMovies.length > 0"
                    v-for="(movie, Index) in filteredMovies"
                    :title="movie.title"
                    :key="Index"
                    class="text-over"
                    v-on:click="
                      newQuickBookFilter(movie, 'cinema', $event, movie.id)
                    "
                    >{{ movie.title }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else>{{
                    $t("NO_MOVIES_FOUND")
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>
              <!-- CINEMA -->
              <div
                v-else
                class="col-xl-3 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2  margin_bottom_small_device align-self-center cinema-dd by-movie-else-movie-c-dd"
              >
                <b-dropdown
                  ref="cinemaDropdown"
                  id="ddown1"
                  no-flip
                  :text="
                    quickBook.cinemaSelected.title == 'Select Cinema'
                      ? $t('SELECT_CINEMA')
                      : quickBook.cinemaSelected.title
                  "
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="
                    onClickMovieDropDown() == true
                      ? onClickCinemaDropDown()
                      : ''
                  "
                  :disabled="
                    quickbookby === 'movie' &&
                      quickBook.movieSelected.title == 'Select Movie'
                  "
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      autofocus
                      required
                      v-on:keyup="onKeyUp('cinema')"
                      v-on:keydown="onKeyUp('cinema')"
                      v-model="cinemaSearch"
                    />
                  </div>

                  <div class="curve">
                    <b-dropdown-item
                      v-for="(cinema, Index) in quickBook.cinemas"
                      :title="cinema.title"
                      :key="Index"
                      class="text-over"
                      id="button-2"
                      v-on:click="
                        newQuickBookFilter(cinema, 'dates', $event, cinema.id)
                      "
                    >
                      {{ cinema.title }}
                      <!-- <b-tooltip target="button-2" placement="left" :title="cinema.CinemaName"></b-tooltip> -->
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </div>

              <!--BY CINEMA-->
              <!-- CINEMA -->
              <div
                v-if="quickbookby == 'movie'"
                class="col-xl-2 col-sm-6 col-md-6 col-lg-6 px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center cinema-dd by-cinema-if-movie-c-dd"
              >
                <b-dropdown
                  ref="cinemaDropdown"
                  id="ddown1"
                  no-flip
                  :text="
                    quickBook.cinemaSelected.title == 'Select Cinema'
                      ? $t('SELECT_CINEMA')
                      : quickBook.cinemaSelected.title
                  "
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="
                    onClickMovieDropDown() == true
                      ? onClickCinemaDropDown()
                      : ''
                  "
                  :disabled="
                    quickbookby === 'movie' &&
                      quickBook.movieSelected.title == 'Select Movie'
                  "
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      autofocus
                      required
                      v-on:keyup="onKeyUp('cinema')"
                      v-on:keydown="onKeyUp('cinema')"
                      v-model="cinemaSearch"
                    />
                  </div>

                  <div class="curve">
                    <b-dropdown-item
                      v-for="(cinema, Index) in quickBook.cinemas"
                      :title="cinema.title"
                      :key="Index"
                      class="text-over"
                      id="button-2"
                      v-on:click="
                        newQuickBookFilter(cinema, 'dates', $event, cinema.id)
                      "
                    >
                      {{ cinema.title }}
                      <!-- <b-tooltip target="button-2" placement="left" :title="cinema.CinemaName"></b-tooltip> -->
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </div>
              <!-- MOVIE -->
              <div
                v-else
                class="col-xl-3 col-sm-6 col-md-6 col-lg-6 px-0 pr-sm-2 px-lg-2  margin_bottom_small_device align-self-center by-cinema-else-movie-m-dd"
              >
                <b-dropdown
                  no-flip
                  ref="dropdown"
                  id="ddown1"
                  :text="
                    quickBook.movieSelected.title == 'Select Movie'
                      ? $t('SELECT_MOVIE')
                      : quickBook.movieSelected.title
                  "
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="onClickMovieDropDown()"
                  :disabled="
                    quickbookby === 'cinema' &&
                      quickBook.cinemaSelected.title == 'Select Cinema'
                  "
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      id="movieSearchId"
                      autofocus
                      required
                      v-on:keyup="onKeyUp('movie')"
                      v-on:keydown="onKeyUp('movie')"
                      v-model="movieSearch"
                    />
                  </div>
                  <b-dropdown-item
                    v-if="filteredMovies.length > 0"
                    v-for="(movie, Index) in filteredMovies"
                    :title="movie.title"
                    :key="Index"
                    class="text-over"
                    v-on:click="
                      newQuickBookFilter(movie, 'cinema', $event, movie.id)
                    "
                    >{{ movie.title }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else>{{
                    $t("NO_MOVIES_FOUND")
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>

              <!-- DATE -->
              <div
                class="col-xl-2 col-sm-6 col-md-6 col-lg px-0 pr-sm-2 margin_bottom_small_device px-lg-2 align-self-center"
              >
                <b-dropdown
                  ref="dateDropdown"
                  id="ddown1"
                  no-flip
                  :text="
                    quickBook.dateSelected.title == 'Select Date'
                      ? $t('SELECT_DATE')
                      : quickBook.dateSelected.title
                  "
                  variant="default"
                  class="tt-dropdown"
                  :disabled="quickBook.cinemaSelected.title == 'Select Cinema'"
                  @toggle="
                    quickBook.cinemaSelected.title != 'Select Cinema'
                      ? onClickDateDropDown()
                      : ''
                  "
                >
                  <b-dropdown-item
                    v-for="(date, Index) in quickBook.dates"
                    :key="Index"
                    v-on:click="
                      newQuickBookFilter(date, 'time', $event, date.id)
                    "
                    >{{ date.title }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <!-- SHOWTIME -->
              <div
                class="col-xl-2 col-sm-6 col-md-6 col-lg px-0 pl-sm-2 px-lg-2 margin_bottom_small_device align-self-center"
              >
                <b-dropdown
                  ref="showtimeDropdown"
                  no-flip
                  id="ddown1"
                  :text="
                    quickBook.timeSelected.title == 'Select Time'
                      ? $t('SELECT_TIME')
                      : quickBook.timeSelected.title
                  "
                  variant="default"
                  class="tt-dropdown"
                  :disabled="quickBook.dateSelected.title == 'Select Date'"
                  @toggle="
                    quickBook.dateSelected.title != 'Select Date'
                      ? onClickShowtimeDropDown()
                      : ''
                  "
                >
                  <b-dropdown-item
                    v-for="(time, Index) in quickBook.times"
                    :key="Index"
                    v-on:click="
                      newQuickBookFilter(time, 'book', $event, time.id)
                    "
                    >
                    <div class="d-flex movie-moon-hover" style="height:25px" @click="checkLateNightPopup(time.Latenightpopup)">
                      <span>{{ time.title }}</span>
                      <figure v-if="time.Latenightpopup" style="margin-left:10px">
                          <img src="@/assets/img/half-moon.svg" />
                      </figure>
                    </div>
                    </b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <div
                class=" col-xl-2 col-md-12 col-lg-12 text-center px-0 pl-lg-2 align-self-center"
              >
                <router-link
                  class="text-white"
                  to
                  v-on:click.native="onClickShowTimes(quickBook.timeSelected)"
                >
                  <button
                    class=""
                    :disabled="
                      movie_link_id &&
                        cinema_id &&
                        show_date &&
                        show_time == false
                    "
                    :class="[
                      movie_link_id == false ||
                      cinema_id == false ||
                      show_date == false ||
                      show_time == false
                        ? 'qb-btn-disabled'
                        : 'qb-btn'
                    ]"
                  >
                    {{ $t("BOOK_NOW") }}
                  </button>
                </router-link>
              </div>
            </div>

            <!--By cinema-->
            <div class="d-flex" v-if="false">
              <!-- CINEMA -->
              <div
                class="col-12 col-sm-6 col-md-6 col-lg px-0 pl-sm-2 px-lg-2 align-self-center cinema-dd"
              >
                <b-dropdown
                  ref="cinemaDropdown"
                  id="ddown1"
                  no-flip
                  :text="quickBook.cinemaSelected.title"
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="
                    onClickMovieDropDown() == true
                      ? onClickCinemaDropDown()
                      : ''
                  "
                  :disabled="quickBook.movieSelected.title == 'Select Movie'"
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      autofocus
                      required
                      v-on:keyup="onKeyUp('cinema')"
                      v-on:keydown="onKeyUp('cinema')"
                      v-model="cinemaSearch"
                    />
                  </div>

                  <div class="curve">
                    <b-dropdown-item
                      v-for="(cinema, Index) in quickBook.cinemas"
                      :title="cinema.title"
                      :key="Index"
                      class="text-over"
                      id="button-2"
                      v-on:click="
                        newQuickBookFilter(cinema, 'dates', $event, cinema.id)
                      "
                    >
                      {{ cinema.title }}
                      <!-- <b-tooltip target="button-2" placement="left" :title="cinema.CinemaName"></b-tooltip> -->
                    </b-dropdown-item>
                  </div>
                </b-dropdown>
              </div>

              <!-- MOVIE -->
              <div
                class="col-12 col-sm-6 col-md-6 col-lg px-0 pr-sm-2 px-lg-2 align-self-center"
              >
                <b-dropdown
                  no-flip
                  ref="dropdown"
                  id="ddown1"
                  :text="quickBook.movieSelected.title"
                  variant="default"
                  class="tt-dropdown wide-dropdown"
                  @toggle="onClickMovieDropDown()"
                >
                  <div class="p-2">
                    <input
                      class="quick-input"
                      type="search"
                      placeholder="..."
                      id="movieSearchId"
                      autofocus
                      required
                      v-on:keyup="onKeyUp('movie')"
                      v-on:keydown="onKeyUp('movie')"
                      v-model="movieSearch"
                    />
                  </div>
                  <b-dropdown-item
                    v-if="filteredMovies.length > 0"
                    v-for="(movie, Index) in filteredMovies"
                    :title="movie.title"
                    :key="Index"
                    class="text-over"
                    v-on:click="
                      newQuickBookFilter(movie, 'cinema', $event, movie.id)
                    "
                    >{{ movie.title }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else>{{
                    $t("NO_MOVIES_FOUND")
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>

              <!-- DATE -->
              <div
                class="col-12 col-sm-6 col-md-6 col-lg px-0 pr-sm-2 px-lg-2 align-self-center"
              >
                <b-dropdown
                  ref="dateDropdown"
                  id="ddown1"
                  no-flip
                  :text="quickBook.dateSelected.title"
                  variant="default"
                  class="tt-dropdown"
                  :disabled="quickBook.cinemaSelected.title == 'Select Cinema'"
                  @toggle="
                    quickBook.cinemaSelected.title != 'Select Cinema'
                      ? onClickDateDropDown()
                      : ''
                  "
                >
                  <b-dropdown-item
                    v-for="(date, Index) in quickBook.dates"
                    :key="Index"
                    v-on:click="
                      newQuickBookFilter(date, 'time', $event, date.id)
                    "
                    >{{ date.title }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>

              <!-- SHOWTIME -->
              <div
                class="col-12 col-sm-6 col-md-6 col-lg px-0 pl-sm-2 px-lg-2 align-self-center"
              >
                <b-dropdown
                  ref="showtimeDropdown"
                  no-flip
                  id="ddown1"
                  :text="quickBook.timeSelected.title"
                  variant="default"
                  class="tt-dropdown"
                  :disabled="quickBook.dateSelected.title == 'Select Date'"
                  @toggle="
                    quickBook.dateSelected.title != 'Select Date'
                      ? onClickShowtimeDropDown()
                      : ''
                  "
                >
                  <b-dropdown-item
                    v-for="(time, Index) in quickBook.times"
                    :key="Index"
                    v-on:click="
                      newQuickBookFilter(time, 'book', $event, time.id)
                    "
                    >{{ time.title }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <!-- BOOK NOW -->
            <!-- :to="{ name: 'checkout', params: { movieID: quickBook.timeSelected.MovieID, scheduleID: quickBook.timeSelected.SchID, seatLayout: quickBook.timeSelected.SeatLayout, props: { 'allShowTimes': allShowTimes } }}" -->
            <div
              class="col-md-12 col-lg-12 text-center px-0 pl-lg-2 align-self-center"
              v-if="false"
            >
              <router-link
                class="text-white"
                to
                v-on:click.native="onClickShowTimes(quickBook.timeSelected)"
              >
                <button class="qb-btn">Book Now</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { makeRequest } from "@/helper/internet.js";
import { uniqBy, filter } from "lodash";
// import moment from "moment";
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
import { isMobile, isIOS, isAndroid } from "mobile-device-detect";

export default {
  data() {
    return {
      quickbookby: "movie",
      mobileQuickBook: false,
      movieSearch: "",
      cinemaSearch: "",
      FavCinemas: [],
      allCinemasFromInitialCall: [],
      quickBook: {
        movies: [],
        allMovies: [],
        allCinemas: [],
        movieSelected: {
          title: "Select Movie"
        },
        cinemaSelected: {
          title: "Select Cinema"
        },
        dateSelected: {
          title: "Select Date"
        },
        timeSelected: {
          title: "Select Time"
        },
        cinemas: [],
        dates: [],
        times: [],
        allData: [],
        filteredData: [],
        allShowTimes: []
      },
      timeSelected: {},
      selection: "movie",
      movie_link_id: "",
      cinema_id: "",
      show_date: "",
      show_time: ""
    };
  },
  computed: {
    ...mapGetters(["isRTL"]),
    filteredMovies() {
      if (
        this.quickBook.cinemaSelected &&
        this.quickBook.cinemaSelected.title !== "Select Cinema" &&
        this.allCinemasFromInitialCall &&
        this.allCinemasFromInitialCall.length &&
        this.quickbookby === "cinema"
      ) {
        let allCinemasID = [
          ...new Set(this.allCinemasFromInitialCall.map(x => x.CinemaID))
        ];
        // let moviesCinemaID = [...new Set(this.quickBook.allMovies.map(m => m.CinemaID))]
        // let filtered = this.quickBook.movies.filter(m => allCinemasID.includes(m.CinemaID))
        // console.log({ allCinemasID, moviesCinemaID, filtered })

        return this.quickBook.movies.filter(m =>
          allCinemasID.includes(m.CinemaID)
        );
      }

      return this.quickBook.movies;
    }
  },
  beforeMount() {
    // this.getNowShowingData();
    // this.getQuickBookDetails();
    // this.getLanguages();
    if (!isMobile) {
      this.mobileQuickBook = true;
    }
    this.requestDataQuickBook({ from: `beforeMount`, setCinemas: true });
    EventBus.$on("ResetQuickBook", data => {
      // EventBus.$emit("ResetQuickBook");
      this.requestDataQuickBook({
        from: `EventBus.$on('ResetQuickBook')`,
        setCinemas: true
      });
    });
  },
  afterMount() {
    this.getAllCountry();
  },
  watch: {
    movieSearch: function(newVal, oldVal) {
      if (newVal.length == 0) {
        this.quickBook.movies = this.quickBook.allMovies;
      }
    }
  },
  methods: {
    checkLateNightPopup(data) {
      if(data){
        this.$refs.LateNightPopup.show();
      }
    },
    closeLateNightPopup() {
      this.$refs.LateNightPopup.hide();
    },
    showQuickBook() {
      this.mobileQuickBook = !this.mobileQuickBook;
    },
    setquickbookby(type = "movie") {
      this.quickBook = {
        ...this.quickBook,
        movieSelected: {
          title: "Select Movie"
        },
        cinemaSelected: {
          title: "Select Cinema"
        },
        dateSelected: {
          title: "Select Date"
        },
        timeSelected: {
          title: "Select Time"
        },
        cinema_id: "",
        show_date: "",
        show_time: ""
      };
      // EventBus.$emit('ResetQuickBook')
      this.quickbookby = type;
      this.$forceUpdate();
    },
    newQuickBookFilter: function(data, type, event, id) {
      // console.log('newQuickBookFilter', {data, type, event, id})

      if (type == "movie") {
        this.quickBook.movieSelected = data;
        this.requestDataQuickBook({ from: `type == 'movie'` });
      } else if (type == "cinema" && this.quickbookby == "movie") {
        this.quickBook.movieSelected = data;
        this.movie_link_id = id;
        this.cinema_id = "";
        this.quickBook.cinemaSelected.title = "Select Cinema";
        this.show_date = "";
        this.quickBook.dateSelected.title = "Select Date";
        this.show_time = "";
        this.quickBook.timeSelected.title = "Select Time";
        this.selection = "cinema";
        this.requestDataQuickBook({ from: `type == 'cinema'` });
      } else if (type == "cinema" && this.quickbookby == "cinema") {
        this.quickBook.movieSelected = data;
        this.movie_link_id = id;
        this.selection = "dates";
        this.show_date = "";
        this.quickBook.dateSelected.title = "Select Date";
        this.show_time = "";
        this.quickBook.timeSelected.title = "Select Time";
        this.requestDataQuickBook({ from: `type == 'dates'` });
      } else if (type == "dates") {
        this.quickBook.cinemaSelected = data;
        this.selection = "dates";
        this.cinema_id = id;
        this.show_date = "";
        this.quickBook.dateSelected.title = "Select Date";
        this.show_time = "";
        this.quickBook.timeSelected.title = "Select Time";
        this.requestDataQuickBook({ from: `type == 'dates'` });
      } else if (type == "time") {
        this.quickBook.dateSelected = data;
        this.selection = "time";
        this.show_date = id;
        this.show_time = "";
        this.quickBook.timeSelected.title = "Select Time";
        this.requestDataQuickBook({ from: `type == 'time'` });
      } else if (type == "book") {
        this.quickBook.timeSelected = data;
        this.selection = "book";
        this.show_time = id;
      }
    },
    requestDataQuickBook: function(meta = {}) {
      let payload = {};
      if (this.quickBook.movieSelected.title == "Select Movie") {
        payload.movieID = this.quickBook.movieSelected.ID;
      } else if (this.quickBook.cinemaSelected.title == "Select Cinema") {
        // payload.movieID = this.quickBook.movieSelected.ID;
        payload.movie_link_id = this.movie_link_id;
      } else if (this.quickBook.dateSelected.title == "Select Date") {
        payload.movie_link_id = this.movie_link_id;
        payload.cinema_id = this.cinema_id;
      } else if (this.quickBook.timeSelected.title == "Select Time") {
        payload.movie_link_id = this.movie_link_id;
        payload.cinema_id = this.cinema_id;
        payload.show_date = this.show_date;
      }

      // console.log('quickBook requestDataQuickBook\n', meta, '\n', {selection: this.selection}, '\n', {payload})

      makeRequest("/QuickBook", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              if (this.selection == "movie") {
                this.quickBook.movies = res.data.data;
                this.quickBook.allMovies = res.data.data;
                // clear other arrays
                if (meta.setCinemas) {
                  this.allCinemasFromInitialCall = [
                    ...new Map(
                      (meta.setCinemas
                        ? res.data.data.map(m => ({
                            distance: "0",
                            id: m.CinemaID,
                            CinemaID: m.CinemaID,
                            movie_link_id: m.id,
                            title: m.CinemaName
                          }))
                        : []
                      ).map((item, key) => [item["CinemaID"], item])
                    ).values()
                  ];
                  this.quickBook.cinemas = [...this.allCinemasFromInitialCall];
                  this.quickBook.allCinemas = [
                    ...this.allCinemasFromInitialCall
                  ];
                } else {
                  this.quickBook.cinemas = [];
                }

                this.quickBook.dates = [];
                this.quickBook.cinemaSelected.title = "Select Cinema";
              } else if (this.selection == "cinema") {
                this.quickBook.cinemas = [];
                this.quickBook.dates = [];
                this.quickBook.times = [];
                this.quickBook.cinemas = res.data.data;
                this.quickBook.allCinemas = res.data.data;
                // clear other arrays
                this.quickBook.cinemaSelected.title = "Select Cinema";
                this.quickBook.dateSelected = {
                  title: "Select Date"
                };
                this.quickBook.timeSelected = {
                  title: "Select Time"
                };

                // open cinema popup
                this.quickbookby === "movie" &&
                  this.$refs.cinemaDropdown &&
                  this.$refs.cinemaDropdown.show();
              } else if (this.selection == "dates") {
                this.quickBook.dates = res.data.data;
                // clear other arrays
                this.quickBook.timeSelected = {
                  title: "Select Time"
                };

                this.quickBook.movieSelected.title == "Select Movie"
                  ? // open movie popup
                    !meta.setCinemas &&
                    this.quickbookby === "cinema" &&
                    this.$refs.dropdown &&
                    this.$refs.dropdown.show()
                  : // open date popup
                    this.$refs.dateDropdown && this.$refs.dateDropdown.show();
              } else if (this.selection == "time") {
                this.quickBook.times = res.data.data;

                // open showtime popup
                this.$refs.showtimeDropdown &&
                  this.$refs.showtimeDropdown.show();
              }
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    onClickShowTimes: function(timeSelected) {
      // this.$refs.tncModal.show();
      console.log("timeSelected :", timeSelected);
      this.timeSelected.movieID = timeSelected.movie_id;
      this.timeSelected.scheduleID = timeSelected.id;
      this.timeSelected.seatLayout = timeSelected.SeatLayout;
      this.$router.push({
        name: "checkout",
        params: {
          movieID: timeSelected.movie_id,
          scheduleID: timeSelected.id,
          seatLayout: timeSelected.SeatLayout,
          props: { allShowTimes: this.allShowTimes }
        }
      });
    },
    onCancel: function() {
      this.$refs.tncModal.hide();
    },
    click() {
      this.$refs.dropdown.show();
    },
    onAccept: function(movieID, timingList) {
      this.$router.push({
        name: "checkout",
        params: {
          movieID: this.timeSelected.movieID,
          scheduleID: this.timeSelected.scheduleID,
          seatLayout: this.timeSelected.seatLayout,
          props: { allShowTimes: this.allShowTimes }
        }
      });
    },
    onKeyUp: function(type) {
      if (type == "movie") {
        if (this.movieSearch.length > 0) {
          this.quickBook.movies = this.quickBook.allMovies.filter(movie => {
            if (
              movie.title.toLowerCase().includes(this.movieSearch.toLowerCase())
            ) {
              return movie;
            }
          });
        } else {
          this.movieSearch = "";
          this.quickBook.movies = this.quickBook.allMovies;
        }
      } else if (type == "cinema") {
        if (this.cinemaSearch.length > 0) {
          this.quickBook.cinemas = this.quickBook.cinemas.filter(cinema => {
            if (
              cinema.title
                .toLowerCase()
                .includes(this.cinemaSearch.toLowerCase())
            ) {
              return cinema;
            }
          });
        } else {
          this.cinemaSearch = "";
          this.quickBook.cinemas = this.quickBook.allCinemas;
        }
      }
    },
    onFocusOut: function() {
      // this.quickBook.movies = this.quickBook.allMovies;
    },
    getStringDate: function(addDay) {
      var date = new Date();
      if (addDay) {
        date.setDate(date.getDate() + 1);
      }
      var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      return day + " " + monthNames[monthIndex] + " " + year;
    },
    onClickMovieDropDown: function() {
      // console.log('onClickMovieDropDown')

      this.movieSearch = "";
      // this.quickBook.movies = this.quickBook.allMovies;
    },
    onClickCinemaDropDown: function() {
      // console.log('onClickCinemaDropDown')

      this.cinemaSearch = "";

      // this.quickBook.cinemas = this.quickBook.allCinemas;
    },
    onClickDateDropDown: function() {
      // console.log('onClickDateDropDown')
    },
    onClickShowtimeDropDown: function() {
      // console.log('onClickShowtimeDropDown')
    },
    getSortDates: async function(array) {
      let Promises = array.sort(function(a, b) {
        // return new Date(a.ShowDate) - new Date(b.ShowDate);
        return (
          new Date(`${a.ShowDate} ${a.ShowTime}`) -
          new Date(`${b.ShowDate} ${b.ShowTime}`)
        );
      });
      return await Promise.all(Promises);
    },
    // getSortDatesTime: async function(array) {
    //   let Promises = array.sort(function(a, b) {
    //     return (
    //       moment(a.ShowTime).format("h:mm:ss a") -
    //       moment(b.ShowTime).format("h:mm:ss a")
    //     );
    //   });
    //   return await Promise.all(Promises);
    // },
    getQuickBookDetails: function() {
      let token = null;
      let payload = {};
      makeRequest("/GetAllCinemasSch", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (!error && res.data) {
            if (!error) {
              this.quickBook.allData = res.data.Data;
              this.FavCinemas = res.data.Cinemas;
              this.getSortDates(res.data.Data)
                .then(result => {
                  // console.log("result :", result);
                  //
                  this.quickBook.allData = result;

                  for (let i in this.quickBook.allData) {
                    if (
                      this.quickBook.allData[i].ShowDate ==
                      this.getStringDate(false)
                    ) {
                      this.quickBook.allData[i].ShowDate = "Today";
                    }
                    if (
                      this.quickBook.allData[i].ShowDate ==
                      this.getStringDate(true)
                    ) {
                      this.quickBook.allData[i].ShowDate = "Tomorrow";
                    }
                  }

                  this.quickBook.filteredData = this.quickBook.allData;
                  this.setValuesQuickBook("movie", true);
                  // this.setValuesQuickBook("cinemas");
                  // this.setValuesQuickBook("dates");
                  // this.setValuesQuickBook("times");
                })
                .catch(err => {
                  console.log("err in sort :", err);
                });
            }
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    setValuesQuickBook: function(filter, allFlag) {
      if (allFlag) {
        this.quickBook.movies = uniqBy(this.quickBook.allData, "Title");
        this.quickBook.allMovies = uniqBy(this.quickBook.movies, "title");
        this.quickBook.cinemas = uniqBy(this.quickBook.allData, "CinemaName");
        this.quickBook.dates = uniqBy(this.quickBook.allData, "ShowDate");
        this.quickBook.times = uniqBy(this.quickBook.allData, "ShowTime");
      }

      // this.quickBook.movies = uniqBy(this.quickBook.filteredData, "Title");
      if (filter == "cinemas") {
        this.quickBook.allCinemas = uniqBy(
          this.quickBook.filteredData,
          "CinemaName"
        );
        this.quickBook.cinemas = uniqBy(
          this.quickBook.filteredData,
          "CinemaName"
        );
      }
      if (filter == "dates") {
        this.quickBook.dates = uniqBy(this.quickBook.filteredData, "ShowDate");
      }
      if (filter == "times") {
        this.quickBook.times = uniqBy(this.quickBook.filteredData, "ShowTime");
      }
      function move(arr, old_index, new_index) {
        while (old_index < 0) {
          old_index += arr.length;
        }
        while (new_index < 0) {
          new_index += arr.length;
        }
        if (new_index >= arr.length) {
          let k = new_index - arr.length;
          while (k-- + 1) {
            arr.push(undefined);
          }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
      }

      this.quickBook.dates = this.quickBook.dates.filter((x, index) => {
        return index < 5;
      });
      let flag =
        this.quickBook.dates.filter(x => x.ShowDate == "Today").length > 0;
      this.quickBook.dates.map((x, index) => {
        if (x.ShowDate == "Today") {
          move(this.quickBook.dates, index, 0);
        }
        if (x.ShowDate == "Tomorrow") {
          move(this.quickBook.dates, index, flag ? 1 : 0);
        }
        return x;
      });
    },
    quickBookFilters: function(data, filter, event) {
      // event.preventDefault();
      this.movieSearch = "";
      this.cinemaSearch = "";
      var that = this;
      if (filter == "movie") {
        this.quickBook.movieSelected = data;
        this.quickBook.filteredData = this.quickBook.allData;
        this.quickBook.cinemaSelected = {
          CinemaName: "Select Cinema"
        };
        this.quickBook.dateSelected = {
          ShowDate: "Select Date"
        };
        this.quickBook.timeSelected = {
          ShowTime: "Select Time"
        };
      }
      if (filter == "cinema") {
        // this.quickBook.filteredData = this.quickBook.allData;
        that.quickBook.cinemaSelected = data;
        this.quickBook.dateSelected = {
          ShowDate: "Select Date"
        };
        this.quickBook.timeSelected = {
          ShowTime: "Select Time"
        };
      }
      if (filter == "date") {
        that.quickBook.dateSelected = data;
        this.quickBook.timeSelected = {
          ShowTime: "Select Time"
        };
      }
      if (filter == "time") {
        that.allShowTimes = that.quickBook.times;
        that.quickBook.timeSelected = data;
      }
      // if (date) {
      //   that.quickBook.dateSelected = date;
      // }

      let data1 = _.filter(that.quickBook.allData, function(schedule) {
        if (
          that.quickBook.movieSelected.Title != "Select Movie" &&
          that.quickBook.movieSelected.Title == schedule.Title
        ) {
          return true;
        }
      });
      data1 = _.filter(data1, function(schedule) {
        if (
          that.quickBook.cinemaSelected.CinemaName != "Select Cinema" &&
          that.quickBook.cinemaSelected.CinemaName == schedule.CinemaName
        ) {
          return true;
        } else if (
          that.quickBook.cinemaSelected.CinemaName == "Select Cinema"
        ) {
          return true;
        }
      });
      data1 = _.filter(data1, function(schedule) {
        if (
          that.quickBook.dateSelected.ShowDate != "Select Date" &&
          that.quickBook.dateSelected.ShowDate == schedule.ShowDate
        ) {
          return true;
        } else if (that.quickBook.dateSelected.ShowDate == "Select Date") {
          return true;
        }
      });
      console.log(data1);
      this.quickBook.filteredData = data1;
      // if (filter != "cinema" || filter == "movie") {
      if (filter == "movie") {
        this.setValuesQuickBook("cinemas");
      }
      if (filter == "cinema") {
        this.setValuesQuickBook("dates");
      }
      if (filter == "date") {
        this.setValuesQuickBook("times");
      }
    },
    selectTime: function(schedule, event) {
      event.preventDefault();
      this.$router.push({
        name: "checkout",
        params: {
          movieID: schedule.movieID,
          scheduleID: schedule.SchID,
          seatLayout: schedule.seatlayout,
          props: { allShowTimes: this.allShowTimes }
        }
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/partials/QuickBook.vue